import React, { createContext, useContext, useReducer } from "react";

const AdminContext = createContext(null);



const initializeState = {
    shopCode: localStorage.getItem('SHC'),
    shops: JSON.parse(localStorage.getItem('SHCS')),
}

export const types = {
    "SET": "SET",
    "SET_SHOPCODE": "SET_SHOPCODE",

}

const reducer = (state, action) => {

    switch (action.type) {
        case types.SET:
            // state = { ...state, shops: action.shops };
            localStorage.setItem('SHCS', JSON.stringify(action.shops))

            break;

        case types.SET_SHOPCODE:
            //localStorage.removeItem('SHC');
            state = { ...state, shopCode: action.shopCode };

            localStorage.setItem('SHC', action.shopCode)
            break;
        default:
            throw Error(`An unknown Action to Admin Reducer ${action.type}`);
    }

    return state;
};

const AdminProvider = ({ children }) => {
    let [state, dispatch] = useReducer(reducer, initializeState, () => initializeState);

    return (
        <AdminContext.Provider value={{ state, dispatch }}>
            {children}
        </AdminContext.Provider>
    )
}

const useAdminContext = () => {
    let context = useContext(AdminContext);
    if (!context) {
        throw Error("AdminContext should be use inside AdminProvider");
    }
    let { state, dispatch } = context;


    return {
        state,
        dispatch,
        types
    }
}


export { AdminProvider, useAdminContext };
